class PartbotCollectionSearch extends HTMLElement {
  constructor() {
    super();

    this.collectionType = this.getAttribute("data-collection-type");
    this.productIds = this.getAttribute("data-product-ids")?.split(",");

    // this.skus = [];
    this.filteredProducts = [];
    this.excludedProducts = [];
    this.vehicle_ids = [];
    this.activeVehicleIds = [];
    this.selectedYear = null;
    this.brands = this.getAttribute("data-vendors")
      ? this.getAttribute("data-vendors").split(",")
      : [];
    this.product_types = this.getAttribute("data-product-types")
      ? this.getAttribute("data-product-types")
          .split("|")
          .filter((str) => str.trim() !== "")
      : [];

    this.facets = this.getAttribute("data-facets")
      ? this.getAttribute("data-facets")
          .split(",")
          .filter((str) => str.trim() !== "")
      : [];

    this.filters = this.getAttribute("data-filters");

    const sortMap = {
      manual: "",
      "best-selling": "_best_selling",
      "title-ascending": "_az",
      "title-descending": "_za",
      "price-ascending": "_price_asc",
      "price-descending": "_price_desc",
      "created-ascending": "_created_asc",
      "created-descending": "_created_desc",
    };

    this.defaultSortBy = sortMap[this.getAttribute("data-sortby")] || "";
    this.selectedIndex = "";

    this.showVehicleSearch =
      this.getAttribute("data-show-vehicle-search") === "true";

    this.partbot_vehicle = localStorage.getItem("partbot_selected_vehicle");
    this.platesearch_ids = [];

    if (this.showVehicleSearch && this.partbot_vehicle) {
      this.partbot_vehicle = JSON.parse(this.partbot_vehicle);
      this.platesearch_ids = this.partbot_vehicle.vehicle_ids;

      const vehicleDescription = document.querySelector(
        ".js-vehicle-description"
      );

      vehicleDescription.textContent = this.partbot_vehicle.description;

      const clearButton = document.querySelector(".js-button-clear-vehicle");
      clearButton.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        localStorage.removeItem("partbot_selected_vehicle");
        localStorage.removeItem("partbot_plate_details");
        location.reload();
      });

      const vehicleNotice = document.querySelector(
        ".js-selected-vehicle-notice"
      );

      vehicleNotice.classList.remove("hidden");
      vehicleNotice.classList.add("flex");

      document.querySelector("vehicle-search").classList.add("hidden");
    }

    this.facetFiltersContainer = this.querySelector("#facet-filters");

    // configure Algolia
    this.algoliaAppId = this.getAttribute("data-algolia-app-id");
    this.algoliaApiKey = this.getAttribute("data-algolia-api-key");
    this.algoliaIndexName = this.getAttribute("data-algolia-index");

    this.startingIndexName = `${this.algoliaIndexName}${this.defaultSortBy}`;

    this.hitsContainer = this.querySelector("#partbot-product-grid");

    // hide the hitsContainer if there is a make parameter in the query string
    if (window.location.search.includes("make=")) {
      this.hitsContainer.style.display = "none";
    }

    // listen for vehicle search changes
    this.onVehicleSearchChange = this.applyVehicleSearchSelection.bind(this);
    this.filterAlgoliaHits = this.processHits.bind(this);

    this.adjustFilterCount = this.adjustAttributeFilterCount.bind(this);

    const searchClient = algoliasearch(this.algoliaAppId, this.algoliaApiKey);

    this.search = instantsearch({
      indexName: this.startingIndexName,
      searchClient,
      routing: false,
      searchFunction: (helper) => {
        if (this.vehicle_ids) {
          this.vehicle_ids.map((id) => {
            helper.addDisjunctiveFacetRefinement("vehicle_ids", id);
          });
          this.vehicle_ids = [];
        }
        helper.search();
      },
      onStateChange: ({ uiState, setUiState }) => {
        // show the container if this.activeVehicleIds is not empty and make is in the query string
        if (
          this.activeVehicleIds.length > 0 &&
          window.location.search.includes("make=")
        ) {
          this.hitsContainer.style.display = "block";
        }

        setUiState(uiState);
      },
    });

    const vehicleIdFilter =
      this.showVehicleSearch && this.platesearch_ids.length > 0
        ? `vehicle_ids:${this.platesearch_ids.join(",")}`
        : [];

    let filters = "";
    if (
      this.brands.length > 0 &&
      this.facets.some((facet) => facet === "Brand")
    ) {
      let brand_filters = this.brands
        .map((brand) => `vendor:'${brand.replace(/'/g, "\\'")}'`)
        .join(" OR ");
      filters = `(${brand_filters})`;
    }

    if (this.product_types.length > 0) {
      let product_type_filters = this.product_types
        .map(
          (product_type) =>
            `product_type:'${product_type.replace(/'/g, "\\'")}'`
        )
        .join(" OR ");
      filters = filters
        ? `${filters} AND (${product_type_filters})`
        : `(${product_type_filters})`;

      // remove leading or trailing |
      filters = filters.replace(/^\s*\|\s*/, "").replace(/\s*\|\s*$/, "");
    }

    if (this.filters) {
      filters = filters
        ? `${filters} AND (${this.filters})`
        : `(${this.filters})`;
    }

    if (vehicleIdFilter.length > 0) {
      filters = filters
        ? `${filters} AND (${vehicleIdFilter})`
        : `(${vehicleIdFilter})`;
    }

    // add published:true to filters
    filters = filters ? `${filters} AND published:true` : `published:true`;

    // if collectionType is Manual, and productIds exists, add productIds to objectId filter
    if (this.collectionType === "Manual" && this.productIds) {
      let productIds = this.productIds;
      let productIdsFilter = productIds
        .map((id) => `objectID:${id}`)
        .join(" OR ");
      // remove any line breaks from productIdsFilter
      productIdsFilter = productIdsFilter.replace(/\n/g, "");
      filters = filters
        ? `${filters} AND (${productIdsFilter})`
        : `(${productIdsFilter})`;
    }

    this.optionalFilters;
    if (this.productIds.length > 0) {
      this.optionalFilters = this.productIds.map(
        (id, index) => `objectID:${id}<score=${this.productIds.length - index}>`
      );
    }

    // CONFIG
    const config = {
      sumOrFiltersScores: true,
      hitsPerPage: this.facets && this.facets.length ? 24 : 24,
      distinct: true,
      filters: filters,
      facetingAfterDistinct: true,
      facets: [
        "vendor",
        "product_type",
        "vehicle_years.year_from",
        "vehicle_years.year_to",
        "attributes",
        "vehicle_makes",
      ].concat(this.facets),
      disjunctiveFacets: [
        "vehicle_years.year_from",
        "vehicle_years.year_to",
        "vehicle_ids",
        "attributes",
        "vehicle_makes",
      ],
    };

    this.search.addWidgets([instantsearch.widgets.configure(config)]);

    // Add Facet Filters
    if (this.facets && this.facets.length) {
      this.facets.forEach((facet) => {
        let node = document.createElement("div");
        node.classList.add("partbot-filter-container");
        let facet_id = facet.replace(/[\s_()]+/g, "-").toLowerCase();
        node.innerHTML = `<div class="partbot-filter-title">${facet
          .replace(/_/g, " ")
          .replace(
            "vendor",
            "brand"
          )}</div><div id='partbot-filter-${facet_id}'></div>`;

        let attr_title = [
          "Brand",
          "Vendor",
          "Product Type",
          "Kit",
          "Assembly",
        ].find((v) => facet.includes(v))
          ? facet
              .replace("Brand", "Vendor")
              .replace("Kit", "Assembly")
              .toLowerCase()
              .replace(/ /g, "_")
          : `attributes.${facet}`;

        this.facetFiltersContainer.appendChild(node);
        this.search.addWidgets([
          instantsearch.widgets.refinementList({
            container: `#partbot-filter-${facet_id}`,
            attribute: attr_title,
            operator: "and",
            limit: 100,
            // sortBy: ["title:desc"],
            autoHideContainer: true,
            templates: {
              item(item, { html }) {
                const { value, label, count, isRefined } = item;
                return html`<div
                  class="${count === 0 &&
                  !isRefined &&
                  "hidden"} relative flex items-start pb-1.5"
                >
                  <div class="flex h-5 items-center">
                    <input
                      class="h-4 w-4 rounded border-background3 text-background3/50 focus:ring-background3 md:border-background3 md:!text-text2/80 md:focus:ring-background3"
                      type="checkbox"
                      value="${value}"
                      checked="${isRefined}"
                    />
                  </div>
                  <div class="ml-3 text-sm">
                    <label
                      for="comments"
                      class="font-medium text-text2/80 md:!text-text2/80"
                      >${label}</label
                    >
                  </div>
                </div>`;
              },
            },
            cssClasses: {
              root: "partbot-filter-values",
              list: "partbot-filter-list",
            },
            transformItems(items) {
              // convert any items labels to Yes or No if true or false
              return items.map((item) => {
                if (item.label === "true") {
                  item.label = "Yes";
                } else if (item.label === "false") {
                  item.label = "No";
                }
                // adjust count by checking if the post year filtering and  if the ...
                _this.adjustFilterCount(item, attr_title);
                return item;
              });
            },
          }),
        ]);
      });
    }

    // sortby
    if (this.defaultSortBy && this.querySelector("#partbot-sortby")) {
      this.search.addWidget(
        instantsearch.widgets.sortBy({
          container: "#partbot-sortby",
          items: [
            { label: "Relevance", value: `${this.algoliaIndexName}` },
            {
              label: "Best Selling",
              value: `${this.algoliaIndexName}_best_selling`,
            },
            {
              label: "Price (Low to High)",
              value: `${this.algoliaIndexName}_price_asc`,
            },
            {
              label: "Price (High to Low)",
              value: `${this.algoliaIndexName}_price_desc`,
            },
            {
              label: "Alphabetical (A-Z)",
              value: `${this.algoliaIndexName}_az`,
            },
            {
              label: "Alphabetical (Z-A)",
              value: `${this.algoliaIndexName}_za`,
            },
          ],
          cssClasses: {
            root: "partbot-sortby",
            select: "partbot-sortby-select",
          },
        })
      );
    }

    // Pagination
    this.search.addWidget(
      instantsearch.widgets.pagination({
        container: "#partbot-pagination",
        autoHideContainer: true,
        padding: 1,
        scrollTo: "#partbot-product-grid",
        templates: {
          first: "First",
          previous: "←",
          next: "→",
          last: "Last",
        },
        cssClasses: {
          list: "pages text-center flex justify-start space-x-3 p-6",
          selectedItem: "active",
          link: "btn-pill flex justify-center",
          disabledItem: "disabled hidden",
          firstPageItem: "control",
          lastPageItem: "control",
          nextPageItem: "control",
          previousPageItem: "control",
        },
      })
    );

    // Add Hits Widget
    const filterM = this.filterAlgoliaHits;
    let _this = this;
    this.search.addWidget(
      instantsearch.widgets.hits({
        container: "#partbot-product-grid",
        // cssClasses: {
        //   list: `${
        //     this.facets && this.facets.length
        //       ? "has-filters grid--3-col-desktop"
        //       : "grid--4-col-desktop"
        //   } grid product-grid grid--2-col-tablet-down`,
        //   item: "grid__item scroll-trigger animate--slide-in",
        // },
        cssClasses: {
          list: `grid grid-cols-2 ${
            this.facets.length > 0
              ? "lg:grid-cols-3 xl:grid-cols-4"
              : "lg:grid-cols-4 xl:grid-cols-5"
          }`,
        },
        templates: {
          item(hit, { html, components, sendEvent }) {
            return html`${ProductCard(hit)}`;
          },
          empty(results, { html }) {
            return html`<div class="empty">
              <div class="max-w-7xl p-12 lg:py-20">
                <h2
                  class="mb-4 text-4xl font-bold tracking-tight text-gray-900"
                >
                  No results found.
                </h2>
                <p class="prose text-lg text-gray-500">
                  Try resetting your vehicle selection or choosing different
                  filters.
                </p>
              </div>
            </div>`;
          },
        },
        transformItems(items) {
          _this.excludedProducts = [];
          _this.filteredProducts = items.filter(filterM, this).filter((i) => i);

          return _this.filteredProducts;
        },
      })
    );

    // Listen for index changes
    this.search.on("render", () => {
      const state = _this.search.helper.state;
      const selectedIndex = state.index;

      if (selectedIndex === _this.algoliaIndexName) {
        if (
          state.optionalFilters !== _this.optionalFilters &&
          _this.optionalFilters &&
          _this.optionalFilters.length
        ) {
          _this.search.helper.setQueryParameter(
            "optionalFilters",
            _this.optionalFilters
          );
          _this.search.helper.searchWithoutTriggeringOnStateChange();
        }
      } else {
        if (state.optionalFilters) {
          _this.search.helper.setQueryParameter("optionalFilters", undefined);
          _this.search.helper.searchWithoutTriggeringOnStateChange();
        }
      }
    });

    this.search.start();

    // Listen for vehicle search changes
    document.addEventListener(
      "vehicle-search-change",
      this.onVehicleSearchChange
    );
  }

  processHits(item) {
    if (this.selectedYear && item.vehicle_years) {
      console.log("selectedYear", this.selectedYear);
      console.log("item.vehicle_years", item.vehicle_years);
      // collect all year_froms <= selectedYear and year_tos >= selectedYear
      var yf_vehicle_ids = [];
      var yt_vehicle_ids = [];
      var yf_permitted, yt_permitted;
      if (
        item.hasOwnProperty("vehicle_years") &&
        item.vehicle_years.hasOwnProperty("year_from") &&
        item.vehicle_years.hasOwnProperty("year_to")
      ) {
        // collect year_froms
        for (var year in item.vehicle_years.year_from) {
          if (year <= this.selectedYear) {
            yf_vehicle_ids.push(item.vehicle_years.year_from[year]);
          }
        }

        // collect year_tos
        for (var year in item.vehicle_years.year_to) {
          if (year >= this.selectedYear) {
            yt_vehicle_ids.push(item.vehicle_years.year_to[year]);
          }
        }

        yf_vehicle_ids = yf_vehicle_ids.flat();
        yt_vehicle_ids = yt_vehicle_ids.flat();

        yf_permitted = this.activeVehicleIds.filter((n) =>
          yf_vehicle_ids.includes(n)
        );

        yt_permitted = this.activeVehicleIds.filter((n) =>
          yt_vehicle_ids.includes(n)
        );

        // remove from results if not permitted
        if (yf_permitted.length === 0 || yt_permitted.length === 0) {
          if (
            !this.excludedProducts.find(
              (existingItem) => existingItem.id === item.id
            )
          ) {
            this.excludedProducts.push(item);
          }
          return false;
        }
      }
    }

    // truncate item.title to 140 characters
    if (item.title.length > 140) {
      item.title = item.title.substring(0, 140) + "...";
    }

    // is multi_variant?
    item.multi_variant = item.variant_skus && item.variant_skus.length > 1;

    // check if the item has a compare_at_price_from value and if it is less than or equal to the price_from value set it to null
    if (
      item.compare_at_price_from &&
      item.compare_at_price_from <= item.price_from
    ) {
      item.compare_at_price_from = null;
    }

    return item;
  }

  adjustAttributeFilterCount(item, attr_title) {
    // return if this.filteredProducts is empty
    if (!this.excludedProducts.length) {
      return item;
    }

    // check if attr_title exists in this.excludedProducts, if not found at top level, check in attributes.
    // reduce the item.count to the number of items that have the attribute
    let count = 0;
    if (this.excludedProducts.length) {
      count = this.excludedProducts.reduce((acc, product) => {
        if (product[attr_title] && product[attr_title].includes(item.value)) {
          return acc + 1;
        } else if (
          product.attributes &&
          product.attributes[attr_title] &&
          product.attributes[attr_title].includes(item.value)
        ) {
          return acc + 1;
        }
        return acc;
      }, 0);
    }

    // adjust the item count
    item.count = item.count - count;

    return item;
  }

  applyVehicleSearchSelection(e) {
    if (this.platesearch_ids && this.platesearch_ids.length) {
      console.log("platesearch_ids", this.platesearch_ids);
      return false;
    }

    if (!this.search.helper) {
      this.vehicle_ids = e.detail.vehicle_ids;
      console.log("vehicle_ids", this.vehicle_ids);
      return false;
    }
    this.search.helper.clearRefinements("vehicle_ids");
    this.search.helper.clearRefinements("vehicle_makes");

    if (e.detail.vehicle.make) {
      this.search.helper.addFacetRefinement(
        "vehicle_makes",
        e.detail.vehicle.make.value
      );
      console.log("vehicle make", e.detail.vehicle.make.value);
    }

    if (e.detail.vehicle.year) {
      this.selectedYear = parseInt(e.detail.vehicle.year.value);
    } else {
      this.selectedYear = null;
    }

    console.log("selectedYear", this.selectedYear);

    this.activeVehicleIds = e.detail.vehicle_ids;

    if (this.activeVehicleIds) {
      this.activeVehicleIds.map((id) => {
        this.search.helper.addDisjunctiveFacetRefinement("vehicle_ids", id);
      });

      console.log("activeVehicleIds", this.activeVehicleIds);

      this.search.helper.search();
    }
  }
}

const ProductCard = (hit) => {
  return `<div class="group relative flex flex-col justify-between h-full md:border-r border-b border-gray-200">
  <div>
    <a href="/products/${hit.handle}?variant=${
    hit.objectID
  }" class="block w-full bg-white overflow-hidden aspect-w-1 aspect-h-1">
    ${
      hit.image
        ? `<img
      src="${hit.image}"
      alt="${hit.title}"
      class="w-full h-full object-center object-cover hover:scale-110 transform scale-100 duration-500 p-4 transition" width="300" height="auto"
      loading="lazy"
      width="794"
      height="798" />`
        : '<div class="flex items-center justify-center text-center text-sm">Image unavailable</div>'
    }
    </a>
    <div class="text-left px-6 md:px-8 pb-4">
        <a href="/products/${hit.handle}?variant=${hit.objectID}" class="block">
		<h3 class="mt-1 text-sm md:text-base font-medium text-gray-900">
      ${hit.title}
			</h3>
		</a>
	  <p class="text-sm text-gray-500 mt-3">SKU: ${hit.sku}</p>
    </div>
  </div>
  <div class="px-6 md:px-8 pb-8">
	<div class="flex justify-start items-end flex-wrap mb-8 space-y-2">
  
    ${
      hit.price_from &&
      `<div class="price">
      <div class="price__container">
        <div class="price__regular">
          <span class="sr-only">Regular price</span>
          <h6 class="text-primary-500 font-bold text-base md:text-2xl">
            ${hit.prices && hit.prices.length > 1 ? "From " : ""}$${
        hit.price_from
      } AUD
          </h6>
        </div>
        ${
          hit.compare_at_price_from &&
          hit.price_from &&
          hit.compare_at_price_from > hit.price_from
            ? `<div class="price__sale">
          <span class="sr-only">Sale price</span>
          <h6 class="font-bold text-gray-500"><del>
            $${hit.compare_at_price_from}</del></h6>
        </div>`
            : ""
        }
      </div>
    </div>
    `
    }

	</div>
    <a href="/products/${hit.handle}?variant=${hit.objectID}" class="btn">
      View Product
    </a>
  </div>
</div>`;

  // return `<div class="card-wrapper product-card-wrapper underline-links-hover">
  //   <div class="card card--standard card--media" style="--ratio-percent: 100%;">
  //     <div class="card__inner color-background-2 gradient ratio" style="--ratio-percent: 100%;">
  //       <div class="card__media">
  //         <a href="/products/${hit.handle}?variant=${
  //   hit.objectID
  // }" class="media media--transparent media--hover-effect">

  //             ${
  //               hit.image
  //                 ? `<img
  //               src="${hit.image}"
  //               alt="${hit.title}"
  //               class="motion-reduce"
  //               loading="lazy"
  //               width="794"
  //               height="798" />`
  //                 : '<div class="flex items-center justify-center text-center text-sm">Image unavailable</div>'
  //             }

  //         </a>
  //       </div>
  //     </div>
  //     <div class="card__content">
  //       <div class="card__information">
  //         <h3 class="card__heading h5">
  //           <a href="/products/${hit.handle}?variant=${
  //   hit.objectID
  // }" class="full-unstyled-link">
  //             ${hit.title}
  //           </a>

  //         </h3>
  //         <div class="card-information">
  //           ${
  //             hit.price_from &&
  //             `<div class="price">
  //             <div class="price__container">
  //               <div class="price__regular">
  //                 <span class="visually-hidden visually-hidden--inline">Regular price</span>
  //                 <span class="price-item price-item--regular">
  //                   ${hit.prices && hit.prices.length > 1 ? "From " : ""}$${
  //               hit.price_from
  //             } AUD
  //                 </span>
  //               </div>
  //               ${
  //                 hit.compare_at_price_from &&
  //                 hit.price_from &&
  //                 hit.compare_at_price_from > hit.price_from
  //                   ? `<div class="price__sale">
  //                 <span class="visually-hidden visually-hidden--inline">Sale price</span>
  //                 <span class="price-item price-item--sale price-item--last">
  //                   $${hit.compare_at_price_from}</span>
  //               </div>`
  //                   : ""
  //               }
  //             </div>
  //           </div>
  //           `
  //           }
  //         </div>
  //       </div>
  //       <div class="quick-add">
  //         <a href="/products/${hit.handle}?variant=${
  //   hit.objectID
  // }" class="quick-add__submit button button--full-width button--secondary tw-uppercase tw-no-underline">
  //           <span>View product</span>
  //         </a>
  //       </div>
  //     </div>
  //   </div>
  // </div>`;
};

customElements.define("partbot-collection-search", PartbotCollectionSearch);
